import {
  CREATE_ACCOUNT_REQUEST,
  CREATE_ACCOUNT_SUCCESS,
  CREATE_ACCOUNT_FAILURE,
  SET_SIGNUP_FAIL_ERROR,
  CONFIRM_SMS_REQUEST,
  CONFIRM_SMS_SUCCESS,
  CONFIRM_SMS_FAILURE,
  RESET_REGISTRATION_STATES,
} from './registrationTypes';
import moment from 'moment';
import { navigate } from 'gatsby';
import app from 'firebase/app';
import api from '../../api';
import appConfig from '../../../app-config';
import { createAlert } from '../../modules/Alert/alertActions';
import { setInterDeliveryDetailsId } from '../OrderSetting/orderSettingActions';
import formatedBEErrorMessage from '../../utils/formatedBEErrorMessage';
import { updateOrderSettingModalIsVisible } from '../OrderSetting/orderSettingActions';
import { validateGlobalCart, updateCartScreen } from '../Cart/cartActions';
import { setLoyaltyRegistrationModalOpen } from '../Loyalty/loyaltyActions';
export function setActiveStep(activeStep) {
  return function(dispatch) {
    dispatch({
      type: 'UPDATE_AUTH_ACTIVE_STEP',
      activeStep: activeStep,
    });
  };
}
export function clearRegistrationErrorMessage() {
  return function(dispatch) {
    dispatch({
      type: 'UPDATE_REGISTERATION_ERROR_MESSAGE',
      errors: {},
    });
  };
}
export function createAccount(values, resetRecaptchaTokenCallback) {
  return function(dispatch, getState) {
    const isPasswordLess = getState().authReducer.appConfig.is_password_less;
    const formBody = {
      ...values,
      source: appConfig.appSource,
      phone_number: values.phone_number.toString(),
    };
    delete formBody.confirm_password;
    dispatch({
      type: 'UPDATE_REGISTERATION_ERROR_MESSAGE',
      errors: {},
    });
    if (isPasswordLess && formBody.password) {
      delete formBody.password;
    }

    if (values.birthdate.length) {
      if (!moment(values.birthdate).isValid()) {
        dispatch(
          createAlert({
            type: 'error',
            message: 'Invalid Birthday',
          })
        );
        return;
      }

      if (moment(values.birthdate).isAfter(moment())) {
        dispatch(
          createAlert({
            type: 'error',
            message: 'Date should not be in the future!',
          })
        );
        return;
      }

      const age = moment().diff(moment(values.birthdate), 'years');
      if (age < 13) {
        dispatch(
          createAlert({
            type: 'error',
            message: 'The minimal required age to register is 13!',
          })
        );
        return;
      }
    }
    dispatch({ type: CREATE_ACCOUNT_REQUEST });
    return api
      .post(
        `/registration`,
        { ...formBody, platform_id: 3 },
        { ignore_interception: true }
      )
      .then((response) => {
        localStorage.setItem(
          `${appConfig.appSource}_token`,
          response.data.data.token
        );
        dispatch({
          type: CREATE_ACCOUNT_SUCCESS,
          token: response.data.data.token,
          registrationPhoneNumber: formBody.phone_number,
        });
        if (isPasswordLess) {
          dispatch({
            type: 'UPDATE_AUTH_ACTION_TYPE',
            actionType: 'registration',
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: CREATE_ACCOUNT_FAILURE,
        });
        const errors = formatedBEErrorMessage(error);
        dispatch({
          type: 'UPDATE_REGISTERATION_ERROR_MESSAGE',
          errors: errors,
        });
        if (resetRecaptchaTokenCallback) resetRecaptchaTokenCallback();
      });
  };
}

export function setSignupFailError(error) {
  return function(dispatch) {
    dispatch({
      type: SET_SIGNUP_FAIL_ERROR,
      error,
    });
  };
}
export function resendRegistrationCode(
  resendObject,
  setPatchPhoneNumberIsVisible
) {
  return function(dispatch) {
    return api
      .patch(`/registration/phone`, resendObject, {
        ignore_interception: true,
      })
      .then((response) => {
        setPatchPhoneNumberIsVisible(false);
        dispatch({
          type: 'UPDATE_REGISTERATION_ERROR_MESSAGE',
          errors: null,
        });
        dispatch({
          type: 'UPDATE_AUTH_ERROR_MESSAGE',
          errors: null,
        });
      })
      .catch((error) => {
        const errors = formatedBEErrorMessage(error);
        dispatch({
          type: 'UPDATE_AUTH_ERROR_MESSAGE',
          errors: error?.response?.data?.errors,
        });
      });
  };
}
export function resendRegistrationCodeNew(setPatchPhoneNumberIsVisible) {
  return function(dispatch, getState) {
    const { registrationPhoneNumber } = getState().registrationReducer;
    const payload = {
      phone_number: registrationPhoneNumber,
      platform_id: 3,
    };
    return api
      .patch(`/registration/phone/resend`, payload, {
        ignore_interception: true,
      })
      .then((response) => {
        setPatchPhoneNumberIsVisible(false);
        dispatch({
          type: 'UPDATE_REGISTERATION_ERROR_MESSAGE',
          errors: null,
        });
        dispatch({
          type: 'UPDATE_AUTH_ERROR_MESSAGE',
          errors: null,
        });
      })
      .catch((error) => {
        const errors = formatedBEErrorMessage(error);
        dispatch({
          type: 'UPDATE_AUTH_ERROR_MESSAGE',
          errors: error?.response?.data?.errors,
        });
      });
  };
}
export function clearVerificationCode(iscleared) {
  return function(dispatch) {
    dispatch({ type: 'TO_CONFIRM_SMS', isCodeCleared: iscleared });
  };
}
export function confirmSMS(confirmCode) {
  return function(dispatch, getState) {
    const actionType = getState().authReducer.actionType;
    const isCodeCleared = getState().registrationReducer.isCodeCleared;
    dispatch({ type: CONFIRM_SMS_REQUEST });
    dispatch({
      type: 'UPDATE_REGISTERATION_ERROR_MESSAGE',
      errors: {},
    });
    let confirmURL;
    if (actionType === 'login' && !isCodeCleared) {
      confirmURL = '/login/verify-code';
    } else if (actionType === 'registration') {
      confirmURL = '/registration/phone/confirmation';
    } else if (isCodeCleared) {
      confirmURL = '/registration/phone/confirmation';
    }
    return api
      .post(confirmURL, confirmCode, {
        ignore_interception: true,
      })
      .then((response) => {
        if (actionType === 'login') {
          dispatch({
            type: 'UPDATE_AUTH_ERROR_MESSAGE',
            errors: {},
          });
          const { status } = response.data.data;
          if (status === 'UNCONFIRMED') {
            dispatch({
              type: 'TO_CONFIRM_SMS',
              isCodeCleared: true,
              unconfirmedPhone: response.data.data.phone_number,
            });
            dispatch({
              type: 'EMAIL_IS_UNCONFIRMED',
              token: response.data.data.token,
            });
            // for unverified phone number
            dispatch({
              type: 'UPDATE_AUTH_ACTION_TYPE',
              actionType: 'registration',
            });
            localStorage.setItem(
              `${appConfig.appSource}_token`,
              response.data.data.token
            );
          } else {
            dispatch({
              type: 'LOGIN_SUCCESS',
              token: response.data.data.token,
            });

            localStorage.setItem(
              `${appConfig.appSource}_token`,
              response.data.data.token
            );
            api.get(`/firebase-token`).then((response) => {
              localStorage.setItem('firebase_token', response.data.data.token);
              app
                .auth()
                .signInWithCustomToken(response.data.data.token)
                .then((userCredential) => {})
                .catch((error) => {});
            });

            if (getState().cartReducer.cartScreen === 'review') {
              dispatch(validateGlobalCart());
            }

            if (getState().cartReducer.cartScreen === 'checkout') {
              updateCartScreen('review');
              navigate('/cart');
              dispatch(updateOrderSettingModalIsVisible(true));
            }
          }

          const { interDeliveryDetails } = getState().orderSettingReducer;
          const config = getState().authReducer.appConfig;
          const {
            guestDeliveryFormInitialAddress,
          } = getState().deliveryAddressesReducer;

          if (
            interDeliveryDetails &&
            !interDeliveryDetails.id &&
            config &&
            config.guest_checkout_enabled
          ) {
            api
              .post('/customer/addresses', guestDeliveryFormInitialAddress)
              .then((res) => {
                if (res.data.data.customer_address_id) {
                  dispatch(
                    setInterDeliveryDetailsId(res.data.data.customer_address_id)
                  );
                }
              });
          }
        } else if (actionType === 'registration') {
          dispatch({
            type: CONFIRM_SMS_SUCCESS,
            confirmSMSIsSuccessful: true,
          });

          const { interDeliveryDetails } = getState().orderSettingReducer;
          const config = getState().authReducer.appConfig;
          const {
            guestDeliveryFormInitialAddress,
          } = getState().deliveryAddressesReducer;

          if (
            interDeliveryDetails &&
            !interDeliveryDetails.id &&
            config &&
            config.guest_checkout_enabled
          ) {
            api
              .post('/customer/addresses', guestDeliveryFormInitialAddress)
              .then((res) => {
                if (res.data.data.customer_address_id) {
                  dispatch(
                    setInterDeliveryDetailsId(res.data.data.customer_address_id)
                  );
                }
              });
          }
          if (appConfig.hasLoyaltyRegistrationModal) {
            dispatch(setLoyaltyRegistrationModalOpen(true));
          }
        }
      })
      .catch((error) => {
        const errors = formatedBEErrorMessage(error);
        dispatch({
          type: 'UPDATE_REGISTERATION_ERROR_MESSAGE',
          errors: errors,
        });
      });
  };
}

export function resetRegistrationStates() {
  return {
    type: RESET_REGISTRATION_STATES,
  };
}

export function setLoginToken() {
  return function(dispatch) {
    dispatch({
      type: 'LOGIN_SUCCESS',
      token: localStorage.getItem(`${appConfig.appSource}_token`),
    });
  };
}
